<template>
	<div class="introduce">
		<div class="introduce_main_box">
			<p align="center" style="text-align: center; text-indent: 2em;">
				<span style="font-size:10.5pt"
					><span style="font-family:Calibri"
						><b
							><span style="font-size:14.0000pt"
								><span style="font-family:黑体"
									><span style="font-weight:bold"
										><font face="黑体">国研网</font
										><font face="黑体"
											>&ldquo;30&middot;60双碳战略研究与决策支撑平台&rdquo;上线公告</font
										></span
									></span
								></span
							></b
						></span
					></span
				>
			</p>

			<p
				align="justify"
				class="p"
				style="padding: 0pt; text-align: justify; text-indent: 2em;"
			>
				<span style="font-size:12pt"
					><span style="text-justify:inter-ideograph"
						><span style="font-family:Calibri"
							><span style="font-size:14.0000pt"
								><span style="font-family:华文仿宋"
									><span style="color:#000000"
										><span style="letter-spacing:0.0000pt"
											><span style="text-transform:none"
												><span style="font-style:normal"
													><font face="华文仿宋"
														>尊敬的用户：</font
													></span
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>

			<p
				align="justify"
				class="p"
				style="padding: 0pt; text-align: justify; text-indent: 2em;"
			>
				<span style="font-size:12pt"
					><span style="text-justify:inter-ideograph"
						><span style="font-family:Calibri"
							><span style="font-size:14.0000pt"
								><span style="font-family:华文仿宋"
									><span style="color:#000000"
										><span style="letter-spacing:0.0000pt"
											><span style="text-transform:none"
												><span style="font-style:normal"
													><font face="华文仿宋"
														>您好！</font
													></span
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>

			<p
				align="justify"
				class="p"
				style="padding: 0pt; text-align: justify; text-indent: 2em;"
			>
				<span style="font-size:12pt"
					><span style="text-autospace:ideograph-numeric"
						><span style="text-justify:inter-ideograph"
							><span style=""
								><span style="font-family:Calibri"
									><span style="font-size:14.0000pt"
										><span style="font-family:华文仿宋"
											><span style=""
												><span style="color:#000000"
													><span
														style="letter-spacing:0.0000pt"
														><span
															style="text-transform:none"
															><span
																style="font-style:normal"
																><font
																	face="华文仿宋"
																	>30&middot;60双碳战略研究与决策支撑平台（后文简称&ldquo;平台&rdquo;）是国研网精心设计打造的一站式综合性双碳信息服务平台，旨在通过及时全面跟踪双碳领域政策动向、实践趋势、学术前沿、典型案例、多维数据等，为有关党政机关、科研院所、企业单位在双碳领域的深入研究与科学决策提供有力支撑</font
																></span
															></span
														></span
													></span
												></span
											></span
										></span
									><span style="font-size:14.0000pt"
										><span style="font-family:华文仿宋"
											><span style=""
												><span style="color:#000000"
													><span
														style="letter-spacing:0.0000pt"
														><span
															style="text-transform:none"
															><span
																style="font-style:normal"
																><font
																	face="华文仿宋"
																	>。</font
																></span
															></span
														></span
													></span
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>

			<p
				align="justify"
				class="p"
				style="padding: 0pt; text-align: justify; text-indent: 2em;"
			>
				<span style="font-size:12pt"
					><span style="text-autospace:ideograph-numeric"
						><span style="text-justify:inter-ideograph"
							><span style=""
								><span style="font-family:Calibri"
									><span style="font-size:14.0000pt"
										><span style="font-family:华文仿宋"
											><span style=""
												><span style="color:#000000"
													><span
														style="letter-spacing:0.0000pt"
														><span
															style="text-transform:none"
															><span
																style="font-style:normal"
																><font
																	face="华文仿宋"
																	>平台以用户需求为导向，推出政策、资讯、报告、论文、案例、数据和专题等专项服务内容，设有权威声音、政策规划、动态资讯、专家评论、学术论文、研究报告、典型案例、双碳实践、统计数据、特色专题十大板块</font
																></span
															></span
														></span
													></span
												></span
											></span
										></span
									><span style="font-size:14.0000pt"
										><span style="font-family:华文仿宋"
											><span style=""
												><span style="color:#000000"
													><span
														style="letter-spacing:0.0000pt"
														><span
															style="text-transform:none"
															><span
																style="font-style:normal"
																><font
																	face="华文仿宋"
																	>。</font
																></span
															></span
														></span
													></span
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>
			<img
				src="../../assets/homeContent/homeImgJt.png"
				style="max-width: 100%;"
				alt=""
			/>
			<p
				align="center"
				class="p"
				style="padding: 0pt; text-align: center; text-indent: 2em; margin: 0px !important;"
			>
				&nbsp;
			</p>

			<p
				align="justify"
				class="p"
				style="padding: 0pt; text-align: justify; text-indent: 2em;"
			>
				<span style="font-size:12pt"
					><span style="text-justify:inter-ideograph"
						><span style="font-family:Calibri"
							><span style="font-size:14.0000pt"
								><span style="font-family:华文仿宋"
									><span style="color:#000000"
										><span style="letter-spacing:0.0000pt"
											><span style="text-transform:none"
												><span style="font-style:normal"
													><font face="华文仿宋"
														>平台积累了丰富的双碳政策文件、重要市场资讯、业内重点数据、学术研究论文以及国际智库报告，能够为政府部门提供清晰的双碳目标政策推演及实施路径，为各大高校提供基础性、前瞻性和创新性的学术研究成果及典型教学案例，为研究机构提供基础数据支撑及国际化的研究视野。平台能够满足市场上对双碳领域的资讯、数据及研究报告需求，有利于提升新时期国内双碳工作开展的质量和效率，提高碳达峰碳中和政策制定、理论研究的科学性和有效性。</font
													></span
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>

			<p
				align="justify"
				class="p"
				style="padding: 0pt; text-align: justify; text-indent: 2em;"
			>
				<span style="font-size:12pt"
					><span style="text-justify:inter-ideograph"
						><span style="font-family:Calibri"
							><span style="font-size:14.0000pt"
								><span style="font-family:华文仿宋"
									><span style="color:#000000"
										><span style="letter-spacing:0.0000pt"
											><span style="text-transform:none"
												><span style="font-style:normal"
													><font face="华文仿宋"
														>目前，平台覆盖双碳领域动态资讯</font
													><font face="华文仿宋"
														>6万多条，学术论文1.6万余篇，借鉴案例300多个，包含双碳领域关键数据指标5万余个，数据保有量超92万条，年更新量超12万条。</font
													></span
												></span
											></span
										></span
									></span
								></span
							><span style="font-size:14.0000pt"
								><span style="font-family:华文仿宋"
									><span style="color:#000000"
										><span style="letter-spacing:0.0000pt"
											><span style="text-transform:none"
												><span style="font-style:normal"
													><font face="华文仿宋"
														>未来，我们</font
													></span
												></span
											></span
										></span
									></span
								></span
							><span style="font-size:14.0000pt"
								><span style="font-family:华文仿宋"
									><span style="color:#000000"
										><span style="letter-spacing:0.0000pt"
											><span style="text-transform:none"
												><span style="font-style:normal"
													><font face="华文仿宋"
														>还将不断</font
													></span
												></span
											></span
										></span
									></span
								></span
							><span style="font-size:14.0000pt"
								><span style="font-family:华文仿宋"
									><span style="color:#000000"
										><span style="letter-spacing:0.0000pt"
											><span style="text-transform:none"
												><span style="font-style:normal"
													><font face="华文仿宋"
														>完善平台</font
													></span
												></span
											></span
										></span
									></span
								></span
							><span style="font-size:14.0000pt"
								><span style="font-family:华文仿宋"
									><span style="color:#000000"
										><span style="letter-spacing:0.0000pt"
											><span style="text-transform:none"
												><span style="font-style:normal"
													><font face="华文仿宋"
														>功能</font
													></span
												></span
											></span
										></span
									></span
								></span
							><span style="font-size:14.0000pt"
								><span style="font-family:华文仿宋"
									><span style="color:#000000"
										><span style="letter-spacing:0.0000pt"
											><span style="text-transform:none"
												><span style="font-style:normal"
													><font face="华文仿宋"
														>，</font
													></span
												></span
											></span
										></span
									></span
								></span
							><span style="font-size:14.0000pt"
								><span style="font-family:华文仿宋"
									><span style="color:#000000"
										><span style="letter-spacing:0.0000pt"
											><span style="text-transform:none"
												><span style="font-style:normal"
													><font face="华文仿宋"
														>丰富平台内容，旨在为用户</font
													></span
												></span
											></span
										></span
									></span
								></span
							><span style="font-size:14.0000pt"
								><span style="font-family:华文仿宋"
									><span style="color:#000000"
										><span style="letter-spacing:0.0000pt"
											><span style="text-transform:none"
												><span style="font-style:normal"
													><font face="华文仿宋"
														>提供更</font
													></span
												></span
											></span
										></span
									></span
								></span
							><span style="font-size:14.0000pt"
								><span style="font-family:华文仿宋"
									><span style="color:#000000"
										><span style="letter-spacing:0.0000pt"
											><span style="text-transform:none"
												><span style="font-style:normal"
													><font face="华文仿宋"
														>加</font
													></span
												></span
											></span
										></span
									></span
								></span
							><span style="font-size:14.0000pt"
								><span style="font-family:华文仿宋"
									><span style="color:#000000"
										><span style="letter-spacing:0.0000pt"
											><span style="text-transform:none"
												><span style="font-style:normal"
													><font face="华文仿宋"
														>优质的</font
													></span
												></span
											></span
										></span
									></span
								></span
							><span style="font-size:14.0000pt"
								><span style="font-family:华文仿宋"
									><span style="color:#000000"
										><span style="letter-spacing:0.0000pt"
											><span style="text-transform:none"
												><span style="font-style:normal"
													><font face="华文仿宋"
														>使用</font
													></span
												></span
											></span
										></span
									></span
								></span
							><span style="font-size:14.0000pt"
								><span style="font-family:华文仿宋"
									><span style="color:#000000"
										><span style="letter-spacing:0.0000pt"
											><span style="text-transform:none"
												><span style="font-style:normal"
													><font face="华文仿宋"
														>体验</font
													></span
												></span
											></span
										></span
									></span
								></span
							><span style="font-size:14.0000pt"
								><span style="font-family:华文仿宋"
									><span style="color:#000000"
										><span style="letter-spacing:0.0000pt"
											><span style="text-transform:none"
												><span style="font-style:normal"
													><font face="华文仿宋"
														>。</font
													></span
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>

			<p
				align="justify"
				class="p"
				style="padding: 0pt; text-align: justify; text-indent: 2em;"
			>
				<span style="font-size:12pt"
					><span style="text-justify:inter-ideograph"
						><span style="font-family:Calibri"
							><span style="font-size:14.0000pt"
								><span style="font-family:华文仿宋"
									><span style="color:#000000"
										><span style="letter-spacing:0.0000pt"
											><span style="text-transform:none"
												><span style="font-style:normal"
													><font face="华文仿宋"
														>感谢您的</font
													></span
												></span
											></span
										></span
									></span
								></span
							><span style="font-size:14.0000pt"
								><span style="font-family:华文仿宋"
									><span style="color:#000000"
										><span style="letter-spacing:0.0000pt"
											><span style="text-transform:none"
												><span style="font-style:normal"
													><font face="华文仿宋"
														>关注与支持，期待您的宝贵意见</font
													></span
												></span
											></span
										></span
									></span
								></span
							><span style="font-size:14.0000pt"
								><span style="font-family:华文仿宋"
									><span style="color:#000000"
										><span style="letter-spacing:0.0000pt"
											><span style="text-transform:none"
												><span style="font-style:normal"
													><font face="华文仿宋"
														>和建议</font
													></span
												></span
											></span
										></span
									></span
								></span
							><span style="font-size:14.0000pt"
								><span style="font-family:华文仿宋"
									><span style="color:#000000"
										><span style="letter-spacing:0.0000pt"
											><span style="text-transform:none"
												><span style="font-style:normal"
													><font face="华文仿宋"
														>！</font
													></span
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>

			<p
				align="justify"
				class="p"
				style="text-align: justify; text-indent: 2em;"
			>
				<span style="font-size:12pt"
					><span style="text-justify:inter-ideograph"
						><span style="font-family:Calibri"
							><span style="font-size:14.0000pt"
								><span style="font-family:华文仿宋"
									><font face="华文仿宋">浏览</font></span
								></span
							><span style="font-size:14.0000pt"
								><span style="font-family:华文仿宋"
									><font face="华文仿宋">网址</font></span
								></span
							><span style="font-size:14.0000pt"
								><span style="font-family:华文仿宋"
									><font face="华文仿宋">：</font></span
								></span
							><u
								><span class="15" style="font-size:14.0000pt"
									><span style="font-family:华文仿宋"
										><span style="color:#0563c1"
											><span
												style="text-decoration:underline"
												><a
													href="https://carbon.drcnet.com.cn"
													target="_blank"
													style="text-underline:single;color: rgb(5, 99, 193);"
													>https://carbon.drcnet.com.cn</a
												></span
											></span
										></span
									></span
								></u
							></span
						></span
					></span
				>
			</p>

			<p
				align="justify"
				class="p"
				style="text-align: justify; text-indent: 2em;"
			>
				<span style="font-size:12pt"
					><span style="text-justify:inter-ideograph"
						><span style="font-family:Calibri"
							><span style="font-size:14.0000pt"
								><span style="font-family:华文仿宋"
									><font face="华文仿宋">客服热线：</font
									><font face="华文仿宋"
										>400-707-0678</font
									></span
								></span
							></span
						></span
					></span
				>
			</p>
		</div>
	</div>
</template>
<script>
import api from '@/../static/common/api/api.js';
import $ from 'jquery';
export default {
	props: {},
	components: {},
	data() {
		return {};
	},
	computed: {},
	methods: {},
	created() {},
	mounted() {},
};
</script>
<style scoped lang="less">
.introduce {
	width: 100%;
	// height: 100%;
	background: #f2f2f2;
}
.introduce_main_box {
	width: 1100px;
	margin: 54px auto 0;
	min-height: 600px;
	background: #fff;
	padding: 50px;
}
.introduce_main_box p {
	font-size: 16px;
	line-height: 2.5;
	// margin-bottom:70px;
	color: #202223;
	font-family: '微软雅黑', 'Heiti SC', '黑体', 'Arial';
}
.introduce_main_box h5 {
	width: 100%;
	text-align: center;
	font-size: 30px;
	font-weight: bold;
	margin: 60px 0 30px;
}
.introduce_main_box strong {
	font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/view/introduce/indexOnLine.vue